import React, { useState } from 'react';
import LabelField from '../Label/LabelField';

const PasswordField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  placeholder,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';

  return (
    <div className="mb-3">
      {label && <LabelField label={label} />}
      <div className="input-group">
        <input
          type={isPassword && showPassword ? 'text' : type}
          className={`form-control`}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...rest}
        />
        {isPassword && (
          <span
            className="input-group-text password-field"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              // Eye open icon
              <i className="bi bi-eye"></i>
            ) : (
              // Eye off icon
              <i className="bi bi-eye-slash"></i>
            )}
          </span>
        )}
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default PasswordField;
